module.exports = __webpack_public_path__ + "static/Unisel8-1af7dfcfeb2f56e3d6ff97ba0f6eb66b.jpg";